// extracted by mini-css-extract-plugin
export default {"wrapper":"qGO_BRT1gnPmbxllapxz","loaderWrapper":"ZKkFfIOJvOX3A26UeVoT","container":"oPR2zLIb7OVURQ7oEAlU","period":"gLJiWARdt6gPd5JwuY8w","hasMultipleLines":"v7zwMWIdh0ezRaqMR4ds"};